import { createAction } from '@ngrx/store';

export const HomeFeature = 'Home';

function getActionName(action: string) {
  return `[${HomeFeature}] ${action}`;
}

export const loadHome = createAction(getActionName('fetch'));
